import React, { useState } from 'react'
import UserHero from '../../userPages/partials/UserHero'
import ListGroup from '../../userPages/partials/ListGroup'
import { Link, useNavigate } from 'react-router-dom'
import { FaForward } from 'react-icons/fa'
import UserAccount from '../../userPages/partials/UserAccount'
import FormValidation from '../../validators/Formvalidators'
import imgageValidation from "../../validators/Imagevalidators"

export default function CreateRoomCart() {
    let [data, setData] = useState({
        name:"",
        pic:"",
        price:0,
        discount:0,
        finalPrice:0,
        stock:true,
        stockQuantity:0,
        message:"",
        active:true,
        
    })
    let [getData,setGetData]= useState()
   let navigate = useNavigate()
    let [show, setShow]=useState(false)
    let [errorMessage, setErrorMessage]=useState({
        name: "Room Type Name  is Required",
    price: "Price  is Required",
    stockQuantity: "Stock Quantity  is Required",
    pic: "Pic  is Required",
    })
  const getInputData=(e)=>{
    let name= e.target.name;
    // let value =e.target.files? e.target.files[0]:e.target.value;
    let value = e.target.files ? e.target?.files: e.target.value;
    
    if(name ==="name" || name==="pic" || name === "message" || name==="price" || name==="discount" || name==="finalPrice" || name==="stock" || name==="stockQuantity" ){
     setErrorMessage((old)=>{
      return{
        ...old,
      [name]:e.target.files ?imgageValidation(e):FormValidation(e)
      }
     })
     setData((old)=>{
      return{
        ...old,
        [name]:value
      }
     })
  }

  
}

 async function postData(e) {
  alert()
  e.preventDefault();
  let error = Object.values(errorMessage).find((x) => x?.length > 0);
  if (error) return setShow(true);

  let response = await fetch("/api/roomcart");
  response = await response.json();

  if (response.result === "Done") {
    let item = Array.isArray(response.data)
      ? response.data.find((x) => x.name.toLowerCase() === data.name.toLowerCase())
      : null;

    if (item) {
      setErrorMessage((old) => ({
        ...old,
        name: "Name already exists",
      }));
    } else {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("message", data.message);
      formData.append("price", parseInt(data.price));
      formData.append("discount", parseInt(data.discount));
      formData.append("finalPrice", parseInt(data.price - data.price * data.discount / 100));
      formData.append("stock", data.stock);
      formData.append("stockQuantity", data.stockQuantity);
      formData.append("active", data.active);

      // ✅ Correct image append
      Array.from(data.pic).forEach((file) => {
        formData.append("pic", file);
      });

      let res = await fetch("/api/roomcart", {
        method: "POST",
        body: formData,
      });

      res = await res.json();
      console.log(res);

      if (res.result === "Done") navigate("/admin/roomcart");
      else alert("Something went wrong");
    }
  }
}


  return (
   <>
   <UserHero/>

   <div className="container">
           <div className="container-fluid mt-3">
            <UserAccount/>
               <div className="row">
               <ListGroup/>
                  <div className="col-md-8">
                  <div className="admin-heading">
                  <h3>CREATE ROOM CART <Link to="/my-account"><FaForward  className='float-end mx-2 ' /></Link> </h3>
                           
                       </div>
                     <form  onSubmit={postData}>
                    <div className="row">
                    <div className="col-md-6 mt-3">
                        <label for="exampleFormControlInput1"  className="form-label">Name*</label>
                        <input type="text" name='name' onChange={getInputData}  className="form-control" id="exampleFormControlInput1" placeholder="Room Type Name"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.name}</p>:""}
                      </div>
                      <div className="col-md-6 mt-3">
                        <label for="exampleFormControlInput1"  className="form-label">Base Price*</label>
                        <input type="number" name='price' onChange={getInputData}  className="form-control" id="exampleFormControlInput1" placeholder="Base Price"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.price}</p>:""}
                      </div>
                    </div>

                    <div className="row">
                    <div className="col-md-6 mt-3">
                        <label for="exampleFormControlInput1"  className="form-label">Discount*</label>
                        <input type="number" name='discount' onChange={getInputData}  className="form-control" id="exampleFormControlInput1" placeholder="Discount"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.discount}</p>:""}
                      </div>
                      <div className="col-md-6 mt-3">
                     <label>Stock*</label>
                  <select
                    name="stock"
                    onChange={getInputData}
                    className="form-select form-label"
                  >
                    <option value="true">In Stock</option>
                    <option value="false">Out of Stock</option>
                  </select>

                     </div>
                    </div>



                    <div className="mb-3 mt-3">
                  <label>Available*</label>
                  <select
                    onChange={getInputData}
                    name="active"
                    className="form-select  form-lable"
                    style={{color:"#ad8b3a"}}
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
                      <div className="mb-3">
                        <label for="exampleFormControlInput1" className="form-label">Pic*</label>
                        <input type="file" name='pic' onChange={getInputData} multiple className="form-control" id="exampleFormControlInput1" placeholder="Enter Your Email"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.pic}</p>:""}
                        
                      </div>
                      <div className="mb-3">
                        <label for="exampleFormControlInput1" className="form-label">Room Stock Quantity *</label>
                        <input type="number" name='stockQuantity' onChange={getInputData} className="form-control" id="exampleFormControlInput1" placeholder="Room Stock Quantity"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.pic}</p>:""}
                        
                      </div>
                 
                       <div className="mb-3">
                         <label for="exampleFormControlTextarea1"  className="form-label">Description*</label>
                         <textarea name='message' onChange={getInputData}  className="form-control" id="exampleFormControlTextarea1" rows="3" placeholder='Address....'></textarea>
                         {show && errorMessage ? <p className='text-danger'>{errorMessage.message}</p>:""}
                       
                       </div>
                       <div className="admmin-update mb-5">
                           <button className='w-100 btn-primary' type='submit'>CREATE</button>
                       </div>
                     </form> 
                  </div>
               </div>
           </div>
          </div>
   </>
  )
}
